import AdministratorSubrouter from './Administrator.subrouter';

export default AdministratorSubrouter;
